import React, { useRef, useState } from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { SlMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlMenu';
import { DownChevronWhite } from 'src/components/SvgIcons';

interface ButtonDropdownOption {
  id: string;
  label: string;
}

interface ButtonDropdownProps {
  label: string;
  options: ButtonDropdownOption[];
  onChange: (option: ButtonDropdownOption) => void;
  variant?: 'contained' | 'normal';
  disabled?: boolean;
  buttonSx?: object;
  textSx?: object;
  /** Position of the dropdown menu relative to the button */
  menuPosition?: 'above' | 'below';
}

const ButtonDropdown: React.FC<ButtonDropdownProps> = ({
  label,
  options,
  onChange,
  variant = 'contained',
  disabled = false,
  buttonSx = {},
  textSx = {},
  menuPosition = 'above'
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const buttonRef = useRef(null);

  const defaultButtonSx = {
    paddingLeft: '12px',
    paddingRight: '4px',
    ...buttonSx
  };

  const defaultTextSx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    ...textSx
  };

  const handleOptionSelect = (option: ButtonDropdownOption) => {
    onChange(option);
    setMenuOpen(false);
  };

  // Anchor and transform origins for menu positioning
  const anchorOrigin =
    menuPosition === 'above'
      ? { vertical: 'top' as const, horizontal: 'left' as const }
      : { vertical: 'bottom' as const, horizontal: 'left' as const };

  const transformOrigin =
    menuPosition === 'above'
      ? { vertical: 'bottom' as const, horizontal: 'left' as const }
      : { vertical: 'top' as const, horizontal: 'left' as const };

  return (
    <>
      <SlButton
        ref={buttonRef}
        variant={variant}
        onClick={() => setMenuOpen(true)}
        disabled={disabled}
        buttonSx={defaultButtonSx}
        textSx={defaultTextSx}
      >
        {label}
        <DownChevronWhite width="24px" height="24px" color="white" />
      </SlButton>
      <SlMenu
        anchorEl={buttonRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        options={options}
        selectedId={null}
        onChange={handleOptionSelect}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        sx={{
          '& .MuiPaper-root': {
            marginBottom: menuPosition === 'above' ? '8px' : undefined,
            marginTop: menuPosition === 'below' ? '8px' : undefined
          }
        }}
      />
    </>
  );
};

export default ButtonDropdown; 